'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAllRequiredConsentCollected = exports.getAllStagedRequiredConsentCollected = exports.getLegalConsentResponses = exports.getStagedLegalConsentResponses = undefined;

var _get = require('transmute/get');

var _get2 = _interopRequireDefault(_get);

var _reselect = require('reselect');

var _BookInfoSelectors = require('./BookInfoSelectors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getStagedLegalConsentResponses = exports.getStagedLegalConsentResponses = (0, _get2.default)('stagedLegalConsentResponses');
var getLegalConsentResponses = exports.getLegalConsentResponses = (0, _get2.default)('legalConsentResponses');

var allRequiredResponsesCollected = function allRequiredResponsesCollected(consentResponses) {
  if (!consentResponses) {
    return false;
  }

  return consentResponses.filter(function (response) {
    return response.required;
  }).every(function (requiredResponse) {
    return requiredResponse.consented;
  });
};

var getAllStagedRequiredConsentCollected = exports.getAllStagedRequiredConsentCollected = (0, _reselect.createSelector)([getStagedLegalConsentResponses], allRequiredResponsesCollected);

var getAllRequiredConsentCollected = exports.getAllRequiredConsentCollected = (0, _reselect.createSelector)([_BookInfoSelectors.getLegalConsentEnabled, getLegalConsentResponses, getStagedLegalConsentResponses], function (legalConsentEnabled, consentResponses, stagedConsentResponses) {
  return !legalConsentEnabled || allRequiredResponsesCollected(consentResponses, stagedConsentResponses);
});


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsLib/target/src/MeetingsLib/static-2.875/js/selectors/LegalConsentFormSelectors.js
// module id = 124
// module chunks = 0